import { useCallback, useEffect, useState } from 'react';
import { useSnackbar } from 'notistack';

import { GetNotifications } from 'services/notificationServices';
import useInterval from 'hooks/useInterval';
import useLocales from './useLocales';

export const useNotificationVersion = (intervalMs = 20_000) => {
  const { translate } = useLocales();
  const { enqueueSnackbar } = useSnackbar();
  const [hasNewVersion, setHasNewVersion] = useState(false);

  const checkVersion = useCallback(async () => {
    try {
      const response = await GetNotifications();
      const latestVersion = response?.version ?? null;
      const currentVersion = localStorage.getItem('version');

      if (!latestVersion) return;

      if (!currentVersion) {
        localStorage.setItem('version', latestVersion);
        return;
      }

      if (currentVersion !== latestVersion) {
        setHasNewVersion(true);
        localStorage.setItem('version', latestVersion);
      }
    } catch (error) {
      enqueueSnackbar(translate('failed_to_fetch_notification'), {
        variant: 'error',
      });
      console.error('Polling notifications failed:', error);
    }
  }, []);

  // initial fetch
  useEffect(() => {
    checkVersion();
  }, [checkVersion]);

  // poll on interval
  useInterval(checkVersion, intervalMs, []);

  return hasNewVersion;
};
